import script from "./TradePassportDbsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportDbsOverview.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportDbsOverview.vue?vue&type=style&index=0&id=06253dca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06253dca"]])

export default __exports__